import api, { apiWrapper } from '../api/axios';

export const getReports = async (
  { from, to, customer = null, client = null, page, pageSize=20, paginate=true, filters = {} }
) => {
  const params = construct_params({ from, to, customer, client, page, page_size: pageSize, paginate });
  // Spread any additional filter params (trip_type, branch, driver, etc.)
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== '' && v !== null && v !== undefined) params[k] = v;
  });
  return apiWrapper(() => api.get(`/trip/mis-reports/`, { params }));
};

export const updateReportSnapshot = async (id, snapshot_data) => {
  const data = { snapshot_data };
  return apiWrapper(() => api.post(`/trip/mis-reports/${id}/update/`, data));
};

export const downloadReportsCSV = async (
  { from, to, customer = null, client = null, page, pageSize, paginate=false, filters = {} }
) => {
  const params = construct_params({ from, to, customer, client, page, page_size: pageSize, paginate });
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== '' && v !== null && v !== undefined) params[k] = v;
  });
  return apiWrapper(() => api.get(`/trip/mis-reports/export/csv/`, { params, responseType: 'blob' }), true, false, true);
};

export const downloadReportsXLSX = async (
  { from, to, customer=null, client=null, page, pageSize, paginate=false, columns=null, filters = {} }
) => {
  const params = construct_params({ from, to, customer, client, page, page_size: pageSize, paginate });
  if (columns && columns.length > 0) {
    params.columns = columns.join(',');
  }
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== '' && v !== null && v !== undefined) params[k] = v;
  });
  return apiWrapper(() => api.get(`/trip/mis-reports/export/xlsx/`, { params, responseType: 'blob' }), true, false, true);
};

const construct_params = (
  {
    from, to, customer, client, page, page_size, paginate
  }
) => {
  let params = { page, page_size, paginate };
  if (from && to) {
    params = {
      ...params,
      from_date: from,
      to_date: to
    };
  }
  // Always send customer and client; null represents "all".
  params = {
    ...params,
    customer: customer ?? null,
    client: client ?? null,
  };
  return params;
};
